import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Icon from "../../assets/icons/Icon";
import { fetchMenusTransaction } from "../../api/menuApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setInventoryTransactionType,
  setSalesTransactionType,
  setTransactionType,
} from "../../redux/slices/transactionTypeSlice";
import { ReportsData } from "./ReportsData";
import { selectRegistration, selectUser } from "../../redux/slices/userSlice";
import { isMobileView, useAcl } from "./CommonFunctions";
import UserProfile from "../UserProfile";
import { posible_logo } from "../../config/imageImport";

const MobileMenu = ({ isOpen, onClose, registaerationData }) => {
  const { getVisibility } = useAcl();
  const [salesTransaction, setSalesTransaction] = useState([]);
  const [inventoryTransaction, setInventoryTransaction] = useState([]);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.store.store);
  const isExpired = store?.NoOfDaysToExpire < 0 || false;

  const [activeReportSubMenu, setActiveReportSubMenu] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const acl = useSelector((state) => state.acl.acl);
  const user = useSelector(selectUser);
  const registration = useSelector(selectRegistration);
  const [showUserProfile, setShowUserProfile] = useState(false);

  const {
    salesReports,
    inventoryReports,
    employeeReports,
    customerReports,
    vendorReports,
    expenseReports,
    loyaltyReports,
  } = ReportsData();

  const showModule = (module, access = "read") => {
    if (!acl) return false;
    const modulePermission = acl.find((e) => e.id == module);
    return !!modulePermission;
  };

  const getFilteredSalesTransactions = () => {
    return salesTransaction.filter((transaction) => {
      const shouldShowModule = showModule(transaction.TransactionType);

      if (registaerationData?.PincodeIntegration) {
        if (
          registaerationData.hasOwnProperty("PinocdeOrderTransactionTypeID") &&
          registaerationData.PinocdeOrderTransactionTypeID === transaction.key
        ) {
          return false;
        }
      }

      return (
        transaction.Module == "sales" &&
        !transaction.IsDeleted &&
        shouldShowModule
      );
    });
  };

  const getFilteredInventoryTransactions = () => {
    return inventoryTransaction.filter((transaction) => {
      const shouldShowModule = showModule(transaction.TransactionType);
      return (
        transaction.Module == "inventory" &&
        !transaction.IsDeleted &&
        shouldShowModule
      );
    });
  };

  // Main menu items with ACL checks (same as desktop)
  const menuItems = [
    // ...(registration?.EnablePosBillingForPincode ? [{
    //   name: "Stockify",
    //   icon: "reports",
    //   subMenu: [{
    //     name: "Pace",
    //     icon: "reports",
    //     link: "https://order-fulfilment-pincode.matrix-prod-aps1.unifyapps.com/login?returnTo=%2F",
    //     external: true,
    //   }],
    // }] : []),

    // ...(registration?.EnablePincodeKirana ? [{
    //   name: "Stockify",
    //   icon: "reports",
    //   subMenu: [{
    //     name: "Pace",
    //     icon: "reports",
    //     link: "https://pace-pincode.matrix-prod-aps1.unifyapps.com/home",
    //     external: true,
    //   }],
    // }] : []),

    // // Online Orders
    // showModule("Onlineorder") && {
    //   name: "Online Orders",
    //   icon: "order",
    //   subMenu: [{ name: "Online Order", icon: "order", link: "/onlineorders" }],
    // },

    // Sales menu
    (showModule("Sales") || getFilteredSalesTransactions().length > 0) && {
      name: "Sales",
      icon: "sales",
      subMenu: [
        {
          name: "Sales History",
          icon: "list",
          link: "/sales/salestransactionlist",
        },
        (showModule("Deliverylist")) && {
          name: "Delivery List",
          icon: "list",
          link: "/sales/deliverylist",
        },
        // showModule("CashRegistersClosing") && {
        //   name: "Cash Register Closing",
        //   icon: "cashregister",
        //   link: "/sales/cashregisterclosinglist",
        // },
        showModule("Packages") && { 
          name: "Packages", 
          icon: "sales", 
          link: "/packages"
        },
        {
          name: "Offline Billing",
          icon: "sales",
         external:true,
          link: "https://billing.posible.in/",
        },
      ].filter(Boolean),
    },

    // Inventory
    (showModule("Inventory")) && {
      name: "Inventory",
      icon: "inventory",
      subMenu: [
        ...getFilteredInventoryTransactions().map((transaction) => ({
          name: transaction.TransactionType,
          link: `/inventory/inventorylist?type=${transaction.TransactionType}&transactionTypeId=${transaction.key}`,
          addIconClick: getVisibility(transaction.TransactionType, "create") ? 
            `/inventory/newinventory?type=${transaction.TransactionType}` : null,
          addIconState: {
            transactionType: transaction,
            type: "New"
          },
        })),
        {
          name: "Inventory list",
          icon: "list",
          link: "/inventory/inventorylist",
        },
        showModule("Intransit") && {
          name: "In transit",
          icon: "list",
          link: "/inventory/intransit",
        },
        showModule("Vendors") && {
          name: "Vendors",
          icon: "vendors",
          link: "/settings/vendors",
          addIconClick: getVisibility("Vendors", "create") ? 
            `/settings/vendors/addvendors` : null,
        },
      ].filter(Boolean),
    },

    // CRM
    (showModule("Customers") ||
      showModule("Campaigns") ||
      showModule("Memberships") ||
      showModule("Coupons")) && {
      name: "CRM",
      icon: "crm",
      subMenu: [
        showModule("Customers") && {
          name: "Customers",
          icon: "customer",
          link: "/crm/customers",
        },
        showModule("Campaigns") && {
          name: "Campaigns",
          icon: "campaign",
          link: "/crm/campaigns",
        },
        showModule("Memberships") && {
          name: "Membership",
          icon: "membership",
          link: "/crm/memberships",
          addIconClick: "/crm/addmembership"
        },
        showModule("Coupons") && {
          name: "Coupons",
          icon: "coupon",
          link: "/crm/coupons",
          addIconClick: "/crm/addcoupon"
        },
        showModule("MessageTemplate") && {
          name: "Message Template",
          icon: "sms",
          link: "/crm/message-template",
        },
      ].filter(Boolean),
    },

    // Loyalty
    showModule("LoyaltyDashboard") && {
      name: "Loyalty",
      icon: "loyalty",
      subMenu: [
        { name: "Loyalty Type", icon: "loyalty", link: "/loyalty/LoyaltyType",addIconClick:"/loyalty/add" },
        { name: "Setup", icon: "setup", link: "/loyalty/Setup" },
      ].filter(Boolean),
    },

    // Appointment
    showModule("Appointment") && {
      name: "Appointment",
      icon: "appointment",
      subMenu: [
        { name: "Appointment", icon: "appointment", link: "/appointment" },
      ],
    },

    // Expense
    (showModule("Expenses") ||
      showModule("AccountManagement") ||
      showModule("ExpenseCategories") ||
      showModule("Account")) && {
      name: "Expense",
      icon: "expense",
      subMenu: [
        { name: "Expense list", icon: "expense", link: "/expense/expenselist" },
        {
          name: "Account management",
          icon: "accountmanagement",
          link: "/expense/transactionlist",
        },
        showModule("ExpenseCategories") && {
          name: "Expense categories",
          icon: "expensecategories",
          link: "/expense/categorieslist",
        },
        { name: "account", icon: "account", link: "/expense/accounts" },
      ].filter(Boolean),
    },

    // Staff
    (showModule("Attendance") || showModule("Employees")) && {
      name: "Staff",
      icon: "staff",
      subMenu: [
        showModule("Attendance") && {
          name: "Attendance",
          icon: "attendance",
          link: "/staff/attendancelist",
        },
        showModule("Employees") && {
          name: "Staff details",
          icon: "staff",
          link: "/settings/employees/",
        },
      ].filter(Boolean),
    },

    // Online Store
    // showModule("Onlinestore") && {
    //   name: "Online store",
    //   icon: "onlinestore",
    //   subMenu: [
    //     showModule("Onlineprofile") && {
    //       name: "profile",
    //       icon: "onlineprofile",
    //       link: "/online-store/profile",
    //     },
    //     showModule("Menubar") && {
    //       name: "Menu",
    //       icon: "menubar",
    //       link: "/online-store/menus",
    //     },
    //     showModule("OnlineStoreSlider") && {
    //       name: "Slider",
    //       icon: "onlinebanner",
    //       link: "/online-store/slider",
    //     },
    //     showModule("Onlinehomesections") && {
    //       name: "Home section",
    //       icon: "onlinehomesections",
    //       link: "/online-store/homesections",
    //       addIconClick: "/onlinestore/NewHomeSection"
    //     },
    //     showModule("Onlineproductdetail") && {
    //       name: "Product details option",
    //       icon: "onlineproductdetail",
    //       link: "/online-store/productdetail",
    //     },
    //     showModule("Onlinepayments") && {
    //       name: "Payment",
    //       icon: "expense",
    //       link: "/online-store/payment",
    //     },
    //     showModule("Onlinepages") && {
    //       name: "Pages",
    //       icon: "onlinepages",
    //       link: "/online-store/pages",
    //     },
    //     showModule("Onlinesettings") && {
    //       name: "Settings",
    //       icon: "setup",
    //       link: "/online-store/settings",
    //     },
    //     showModule("OnlinePaymentTransactions") && {
    //       name: "Payment gateway transactions",
    //       icon: "list",
    //       link: "/online-store/onlinepaymenttransactions",
    //     },
    //   ].filter(Boolean),
    // },

    // Catalogue
    (showModule("Products") ||
      showModule("Categories") ||
      showModule("Subcategories") ||
      showModule("Brands")) && {
      name: "Catalogue",
      icon: "catalogue",
      subMenu: [
        showModule("Products") && {
          name: "Product",
          icon: "product",
          link: "/catalogue/product",
          addIconClick: "/catalogue/product/Addproduct",
        },
        showModule("Productquickedit") && {
          name: "Product - Quick Edit",
          icon: "product",
          link: "/catalogue/pincodeproductquickedit",
        },
        showModule("Aggregatorproducts") && {
          name: "Aggregator products",
          icon: "product",
          link: "/catalogue/product",
          addIconClick: "/catalogue/product/Addproduct",
        },
        showModule("ProductCategories") && {
          name: "Category",
          icon: "category",
          link: "/catalogue/category",
        },
        showModule("ProductCategories") && {
          name: "Subcategory",
          icon: "subcategory",
          link: "/catalogue/subcategory",
        },
        showModule("ProductBrands") && {
          name: "Brand",
          icon: "brand",
          link: "/catalogue/brands",
        },
        showModule("ProductTaxes") && {
          name: "Taxes",
          icon: "taxes",
          link: "/catalogue/taxes",
        },
        showModule("ProductTags") && {
          name: "Product group",
          icon: "vendors",
          link: "/catalogue/product-group",
        },
        showModule("Offers") && {
          name: "Offers",
          icon: "offers",
          link: "/catalogue/offers",
          addIconClick: "/catalogue/offers/newoffer",
        },
        showModule("BOM") && {
          name: "Bom",
          icon: "bom",
          link: "/catalogue/bom",
        },
      ].filter(Boolean),
    },

    // Setup
    showModule("Setup") && {
      name: "Setup",
      icon: "setup",
      subMenu: [
          {
          name: "Get Started",
          icon: "flash",
          link: "/setup/getstarted",
        },
        showModule("Newregistration") && {
          name: "New registration",
          icon: "registration",
          link: "/settings/registration",
        },
        showModule("Registration") && {
          name: "Registration",
          icon: "registration",
          link: "/settings/registration",
        },
        {
          name: "Sales Channel",
          icon: "customfields",
          link: "/setup/saleschannel",
        },
        showModule("Stores") && {
          name: "Stores",
          icon: "stores",
          link: "/settings/stores",
        },
        showModule("PaymentTypes") && {
          name: "Payment types",
          icon: "paymenttypes",
          link: "/settings/paymenttypes",
        },
        showModule("CustomRoles") && {
          name: "Custom roles",
          icon: "adduser",
          link: "/settings/customroles",
        },
        showModule("TransactionTypes") && {
          name: "Module configuration",
          icon: "moduleconfiguration",
          link: "/settings/moduleconfig",
        },
        showModule("CustomFields") && {
          name: "Custom fields",
          icon: "customfields",
          link: "/settings/customfields",
        },
        {
          name: "Transaction SMS template",
          icon: "sms",
          link: "/settings/transactionalsmstemplates",
        },
        showModule("Addtionalsettings") && {
          name: "Additional settings",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        showModule("Pincodesettings") && {
          name: "Pincode settings",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        showModule("Onboarding") && {
          name: "On Boarding",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        showModule("Tables") && {
          name: "Tables",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        {
          name: "Integration",
          icon: "integration",
          link: "/integration",
        },
      ].filter(Boolean),
    },

    // Reports
    showModule("Reports") && {
      name: "Reports",
      icon: "reports",
      subMenu: [
        showModule("NewDashboard") && {
          name: "Dashboard",
          icon: "dashboard",
          link: "/home",
        },
        showModule("Reports") && {
          name: "All Reports",
          icon: "reports",
          link: "/reports/allreports",
        },
        // salesReports.length > 0 && {
        //   name: "Sales Reports",
        //   icon: "sales",
        //   subMenuItems: salesReports,
        // },
        // inventoryReports.length > 0 && {
        //   name: "Inventory Reports",
        //   icon: "inventory",
        //   subMenuItems: inventoryReports,
        // },
        // employeeReports.length > 0 && {
        //   name: "Employee Reports",
        //   icon: "staff",
        //   subMenuItems: employeeReports,
        // },
        // customerReports.length > 0 && {
        //   name: "Customer Reports",
        //   icon: "customer",
        //   subMenuItems: customerReports,
        // },
        // vendorReports.length > 0 && {
        //   name: "Vendor Reports",
        //   icon: "vendors",
        //   subMenuItems: vendorReports,
        // },
        // expenseReports.length > 0 && {
        //   name: "Expense Reports",
        //   icon: "expense",
        //   subMenuItems: expenseReports,
        // },
        // loyaltyReports.length > 0 && {
        //   name: "Loyalty Reports",
        //   icon: "loyalty",
        //   subMenuItems: loyaltyReports,
        // },
        {
          name: "Downloaded Reports",
          icon: "download",
          link: "/reports/downloadedreports",
        },
      ].filter(Boolean),
    },
  ].filter(Boolean);

  const location = useLocation();
  const navigate = useNavigate();

  const handleSetActiveMenu = (menu) => {
    if (activeMenu?.name === menu.name) {
      setActiveMenu(null);
      setActiveReportSubMenu(null);
    } else {
      setActiveMenu(menu);
    }
  };

  const handleReportSubMenuClick = (subMenuName) => {
    setActiveReportSubMenu(
      activeReportSubMenu === subMenuName ? null : subMenuName
    );
  };

  const handleSubMenuItemClick = (subMenu, e = null) => {
    if (e) {
      e.stopPropagation();
    }
    
    if (subMenu.external) {
      window.open(subMenu.link, '_blank');
    } else if (subMenu.link) {
      navigate(subMenu.link);
    }
    
    onClose();
    setActiveMenu(null);
    setActiveReportSubMenu(null);
  };

  const handleAddIconClick = (subMenu, e) => {
    e.stopPropagation();
    if (subMenu.addIconClick) {
      navigate(subMenu.addIconClick, {
        state: subMenu.addIconState
      });
      onClose();
      setActiveMenu(null);
      setActiveReportSubMenu(null);
    }
  };

  const fetchMenus = async () => {
    try {
      const response = await fetchMenusTransaction();
      dispatch(setTransactionType(response.transactionTypes));
      const dataForSales = response.transactionTypes.filter(
        (transaction) => !transaction.IsDeleted && transaction.Module === "sales"
      );
      setSalesTransaction(dataForSales);
      dispatch(setSalesTransactionType(dataForSales));
      const dataForInventory = response.transactionTypes.filter(
        (transaction) => !transaction.IsDeleted && transaction.Module === "inventory"
      );
      setInventoryTransaction(dataForInventory);
      dispatch(setInventoryTransactionType(dataForInventory));
    } catch (err) {
      console.log(err, "while fetching the menu data");
    }
  };

  useEffect(() => {
    fetchMenus();
  }, [acl]);

  // Close menu when route changes
  // useEffect(() => {
  //   if (isOpen) {
  //     onClose();
  //   }
  // }, [location.pathname]);

  return (
    <>
      {/* Mobile menu overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-gray-500/45 z-40"
          onClick={onClose}
        />
      )}

      {/* Mobile menu drawer */}
      <div 
        className={`fixed top-0 left-0 h-full bg-gray-900 text-white z-50 w-[80%] transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="p-4 border-b border-gray-700 flex justify-between items-center">
          <img 
            src={posible_logo} 
            alt="Logo" 
            className="h-10 cursor-pointer"
            onClick={() => {
              navigate("/home");
              onClose();
            }}
          />
          <button 
            className="text-white w-7"
            onClick={onClose}
          >
            <Icon type="remove" />
          </button>
        </div>

        <div className="overflow-y-auto h-full pb-20">
          {/* Main menu items */}
          {!isExpired && menuItems
            .filter(menu => menu.name !== "Setup")
            .map((menu, index) => (
              <div key={index} className="border-b border-gray-700">
                <div
                  className={`flex items-center justify-between p-4 cursor-pointer ${
                    activeMenu?.name === menu.name ? "bg-gray-800" : ""
                  } hover:bg-gray-800 transition-colors`}
                  onClick={() => handleSetActiveMenu(menu)}
                >
                  <div className="flex items-center">
                    <span className="mr-3 w-5">
                      <Icon type={menu.icon} />
                    </span>
                    <span className="capitalize">{menu.name}</span>
                  </div>
                  <svg
                    className={`w-4 h-4 transition-transform ${
                      activeMenu?.name === menu.name ? "rotate-90" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>

                {activeMenu?.name === menu.name && (
                  <div className="bg-gray-800 p-2">
                    {menu.subMenu.map((subMenu, subIndex) => {
                      if (subMenu.subMenuItems) {
                        return (
                          <div key={subIndex} className="mb-2">
                            <div
                              className={`flex items-center justify-between p-2 cursor-pointer rounded ${
                                activeReportSubMenu === subMenu.name ? "bg-gray-700" : ""
                              } hover:bg-gray-700 transition-colors`}
                              onClick={() => handleReportSubMenuClick(subMenu.name)}
                            >
                              <div className="flex items-center">
                                {subMenu.icon && (
                                  <span className="mr-2 w-5">
                                    <Icon type={subMenu.icon} />
                                  </span>
                                )}
                                <span className="text-sm">{subMenu.name}</span>
                              </div>
                              <svg
                                className={`w-4 h-4 transition-transform ${
                                  activeReportSubMenu === subMenu.name ? "rotate-90" : ""
                                }`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </div>

                            {activeReportSubMenu === subMenu.name && (
                              <div className="ml-4 mt-1 border-l border-gray-600">
                                {subMenu.subMenuItems.map((item, itemIndex) => (
                                  <NavLink
                                    key={itemIndex}
                                    to={item.link}
                                    className={({ isActive }) => 
                                      `block p-2 text-sm rounded hover:bg-gray-700 transition-colors ${
                                        isActive ? "bg-gray-700" : ""
                                      }`
                                    }
                                    onClick={onClose}
                                  >
                                    <div className="flex items-center pl-2">
                                      {item.icon && (
                                        <span className="mr-2 w-4">
                                          <Icon type={item.icon} />
                                        </span>
                                      )}
                                      <span>{item.name}</span>
                                    </div>
                                  </NavLink>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      } else {
                        const isActive = location.pathname.startsWith(
                          subMenu.link?.split("?")[0]
                        ) || (
                          subMenu.addIconClick &&
                          location.pathname.startsWith(subMenu.addIconClick)
                        );

                        if (subMenu.external) {
                          return (
                            <a
                              key={subIndex}
                              href={subMenu.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`block p-2 rounded hover:bg-gray-700 transition-colors ${
                                isActive ? "bg-gray-700" : ""
                              }`}
                              onClick={(e) => handleSubMenuItemClick(subMenu, e)}
                            >
                              <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                  {subMenu.icon && (
                                    <span className="mr-2 w-5">
                                      <Icon type={subMenu.icon} />
                                    </span>
                                  )}
                                  <span className="text-sm">{subMenu.name}</span>
                                </div>
                              </div>
                            </a>
                          );
                        }

                        return (
                          <div key={subIndex} className="relative">
                            <div
                              className={`flex py-4 items-center justify-between p-2 rounded hover:bg-gray-700 transition-colors cursor-pointer ${
                                isActive ? "bg-gray-700" : ""
                              }`}
                              onClick={(e) => handleSubMenuItemClick(subMenu, e)}
                            >
                              <div className="flex items-center">
                                {subMenu.icon && (
                                  <span className="mr-2 w-5">
                                    <Icon type={subMenu.icon} />
                                  </span>
                                )}
                                <span className="text-sm">{subMenu.name}</span>
                              </div>
                              {subMenu.addIconClick && (
                                <button
                                  onClick={(e) => handleAddIconClick(subMenu, e)}
                                  className="text-gray-400 hover:text-white p-1 rounded"
                                >
                                  <svg
                                    className="h-5 w-5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M12 4v16m8-8H4"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                )}
              </div>
            ))}

          {/* Setup menu */}
          {(menuItems.find((item) => item.name === "Setup") && !isExpired) && (
            <div className="border-b border-gray-700">
              <div
                className={`flex items-center justify-between p-4 cursor-pointer ${
                  activeMenu?.name === "Setup" ? "bg-gray-800" : ""
                } hover:bg-gray-800 transition-colors`}
                onClick={() => {
                  const Setup = menuItems.find((item) => item.name === "Setup");
                  handleSetActiveMenu(Setup);
                }}
              >
                <div className="flex items-center">
                  <span className="mr-3 w-5">
                    <Icon type={"setup"} />
                  </span>
                  <span className="capitalize">Setup</span>
                </div>
                <svg
                  className={`w-4 h-4 transition-transform ${
                    activeMenu?.name === "Setup" ? "rotate-90" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>

              {activeMenu?.name === "Setup" && (
                <div className="bg-gray-800 p-2">
                  {activeMenu.subMenu.map((subMenu, subIndex) => {
                    const isActive = location.pathname.startsWith(
                      subMenu.link?.split("?")[0]
                    );

                    return (
                      <NavLink
                        key={subIndex}
                        to={{
                          pathname: subMenu.link?.split("?")[0],
                          search: subMenu.link?.includes("?")
                            ? `?${subMenu.link?.split("?")[1]}`
                            : "",
                        }}
                        className={({ isActive }) => 
                          `block p-4 rounded hover:bg-gray-700 transition-colors ${
                            isActive ? "bg-gray-700" : ""
                          }`
                        }
                        onClick={onClose}
                      >
                        <div className="flex items-center">
                          {subMenu.icon && (
                            <span className="mr-2 w-5">
                              <Icon type={subMenu.icon} />
                            </span>
                          )}
                          <span className="text-sm">{subMenu.name}</span>
                        </div>
                      </NavLink>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* User Profile Button */}
          <div className="p-4 border-t border-gray-700">
            <div
              onClick={() => setShowUserProfile(true)}
              className="flex items-center justify-center p-2 rounded bg-gray-800 hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <span className="mr-2 w-5">
                <Icon type="user" />
              </span>
              <span>User Profile</span>
            </div>
          </div>
        </div>
      </div>

      {/* User Profile Modal */}
      {showUserProfile && (
            <UserProfile
              onClose={() => {
                setShowUserProfile(false);
                onClose();
              }}
            />
        
      )}
    </>
  );
};

export default MobileMenu;